import { render, staticRenderFns } from "./OrdersGeneralTable.vue?vue&type=template&id=3717b878&scoped=true&"
import script from "./OrdersGeneralTable.vue?vue&type=script&lang=js&"
export * from "./OrdersGeneralTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/black-dashboard/components/_campaigns-general-table.scss?vue&type=style&index=0&id=3717b878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3717b878",
  null
  
)

export default component.exports